import Glide from "./glide/conteudo/glide.min.js"
import sal from './sal/sal.js'

if (document.readyState !== 'loading') {
    console.log('document is already ready, just execute code here');
    setTimeout(iniciar, 2500);
} else document.addEventListener('DOMContentLoaded', (event) => {
    console.log('loaded')
    setTimeout(iniciar, 2500);
});

document.addEventListener('scroll', initOnEvent);
document.addEventListener('mousemove', initOnEvent);
document.addEventListener('touchstart', initOnEvent);

function initOnEvent(event) {
    iniciar();
    event.currentTarget.removeEventListener(event.type, initOnEvent); // remove the event listener that got triggered
}

function initGtm(w, d, s, l, i) {
    w[l] = w[l] || []; w[l].push({
        'gtm.start':
            new Date().getTime(), event: 'gtm.js'
    }); var f = d.getElementsByTagName(s)[0],
        j = d.createElement(s), dl = l != 'dataLayer' ? '&l=' + l : ''; j.async = true; j.src =
            'https://www.googletagmanager.com/gtm.js?id=' + i + dl; f.parentNode.insertBefore(j, f);
}


function initPixel(f, b, e, v, n, t, s) {
    if (f.fbq) return; n = f.fbq = function () {
        n.callMethod ?
            n.callMethod.apply(n, arguments) : n.queue.push(arguments)
    };
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = !0;
    n.version = '2.0';
    n.queue = []; t = b.createElement(e); t.async = !0;
    t.src = v; s = b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t, s);


    fbq('init', '587527279947953');
    fbq('track', 'PageView');
}

function iniciar() {
    console.log('Iniciar libs')
    if (window.DidInit) {
        return false;
    }
    window.DidInit = true;

    try {
        initGtm(window, document, 'script', 'dataLayer', 'GTM-KKXW9PG9');
        // initPixel(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
    } catch {
        console.log('Erro ao iniciar o pixel')
    }

    sal({
        threshold: 0.01,
        once: false,
    });

    const opt = {
        type: 'carousel',
        startAt: 0,
        focusAt: 'center',
        autoplay: 4000,
        hoverpause: true,
        gap: 4,
    }
    const glide = new Glide('#slider-clientes', {
        ...opt,
        perView: 5,
        autoplay: 7000,
        breakpoints: {
            600: { perView: 1 },
            900: { perView: 3 },
        },
        peek: 50,
    })
    glide.on('run.after', function () {
        window.dispatchEvent(new Event('resize'));
    })
    glide.mount()

    var splide = new Glide('#slide-projetos', {
        ...opt,
        perView: 3,
        breakpoints: {
            600: { perView: 1 },
            900: { perView: 2 },
        }
    });
    splide.on('run.after', function () {
        window.dispatchEvent(new Event('resize'));
    })
    splide.mount();
}